/**
* 区域管理
*/
<template>
  <div>
    <!-- 引入任务管理 -->
    <div v-show="See">
      <task />
      <div @click="close()">
        <img class="close" src="../../assets/img/close.png" />
      </div>
    </div>
    <div v-show="isShow" style="margin:20px">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>区域管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="区域名称:">
          <el-input size="small" v-model="formInline.areaName" placeholder="输入区域名称"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table :data="listData" border element-loading-text="拼命加载中" style="width: 100%">
        <el-table-column align="center" label-aligin="center" prop="id" fixed label="ID" width="80"></el-table-column>
        <el-table-column
          align="center"
          label-aligin="center"
          prop="areaName"
          width="200"
          label="区域名称"
        ></el-table-column>
       
        <el-table-column
          align="center"
          label-aligin="center"
          prop="areaNumber"
          width="250"
          label="区域线路数"
        ></el-table-column>
        <el-table-column
          align="center"
          label-aligin="center"
          prop="areaNumber"
          width="250"
          label="区域车辆数"
        ></el-table-column>
        <el-table-column
          align="center"
          label-aligin="center"
          prop="areaNumber"
          width="250"
          label="创建时间"
        ></el-table-column>
        <el-table-column align="center" label-aligin="center" prop="remarks" width="400" label="备注"></el-table-column>

        <el-table-column align="center" label-aligin="center" label="操作" fixed="right" width="300">
          <template slot-scope="scope">
            <el-button round size="mini" @click="task(scope.row)">任务管理</el-button>
            <el-button round size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button round size="mini" type="danger" @click="delRegion(scope.row)">删除</el-button>
            <!-- <el-button size="mini" @click="handleOperation(scope.row)">操作</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- 添加界面 -->
      <el-dialog
        :title="title"
        :visible.sync="addFormVisible"
        width="30%"
        @click="closeDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <div style="margin-right: 5%">
          <el-form label-width="120px" :model="addForm" :rules="rules" ref="addForm">
            <el-form-item label="区域名称" prop="areaName">
              <el-input
                size="small"
                v-model="addForm.areaName"
                auto-complete="off"
                placeholder="请输入区域名称"
              ></el-input>
            </el-form-item>
            
            <el-form-item label="备注" prop="remarks">
              <el-input
                size="small"
                type="textarea"
                v-model="addForm.remarks"
                auto-complete="off"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog('addForm')">取 消</el-button>
          <el-button type="primary" @click="closeDialog('addForm')">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog
        :title="title"
        :visible.sync="editFormVisible"
        width="30%"
        @click="closeDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <div style="margin-right: 5%">
          <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
            <el-form-item label="区域名称" prop="areaName">
              <el-input
                size="small"
                v-model="editForm.areaName"
                auto-complete="off"
                placeholder="请输入区域名称"
              ></el-input>
            </el-form-item>
      
            <el-form-item label="备注" prop="remarks">
              <el-input
                size="small"
                type="textarea"
                v-model="editForm.remarks"
                auto-complete="off"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            size="small"
            type="primary"
            :loading="loading"
            class="title"
            @click="submitForm('editForm')"
          >保存</el-button>
          <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        </div>
      </el-dialog>

  
    </div>
  </div>
</template>

<script>

import Pagination from "../../components/Pagination";
import task from "../area_mn/task_mn";
export default {
  data() {
    return {
      See: false,
      isShow: true,
      addForm: false,
      outerline: false,
      outerVisible: false,
      innerVisible: false,
      lineVisible: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      car_ids: [],
      car_idsval: [],
      line_ids: [],
      line_idsval: [],
      //区域车辆表单数据
      tableData: [],
      //车辆区域添加
      carData: [],
      //区域线路表单数据
      lineData: [],
      //线路区域添加
      addline: [],

      title: "添加",
      addForm: {
        id: "",
        areaName: "",
        areaNumber: "",
        remarks: ""
      },
      editForm: {
        id: "",
        areaName: "",
        areaNumber: "",
        remarks: ""
      },
      // rules表单验证
      rules: {
        areaName: [
          { required: true, message: "请输入区域名称", trigger: "blur" },
          {
            pattern: /^[\u0391-\uFFE5]+$/,
            message: "请输入准确的区域名称，如：智能装备产业园",
            trigger: "blur"
          }
        ],
        areaNumber: [
          { required: true, message: "请输入区域编号", trigger: "blur" },
          {
            pattern: /^[A-Z]{4}\d{4}$/,
            message: "请输入准确的区域编号，如：STCA0001",
            trigger: "blur"
          }
        ]
      },
      formInline: {
        id: "",
        areaName: "",
        areaNumber: "",
        page: 1,
        limit: 10
      },
      carInline: {
        id: "",
        car_number: "",
        car_id: "",
        name: "",
        page: 1,
        limit: 10
      },
      lineInline: {
        id: "",
        line_name: "",
        line_id: "",
        status: "",
        page: 1,
        limit: 10
      },
      listData: [], //用户数据
      // listData:[{ id: "1",areaName: "1111",areaNumber: "11111111",remarks: ''​}],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pageCar: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pageLine: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
    task
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
    this.getStore();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStore() {
      // this.$store.commit("isShow");
    },
    // 跳转任务管理界面
    task(row) {
      console.log("11111111111");
      this.isShow = false;
      this.See = true;
      // window.localStorage.setItem("area_id", row.id);
      // this.$router.push("/area_mn/task_mn");
    },
    // 关闭任务管理界面
    close() {
      this.isShow = true;
      this.See = false;
    },

    // 获取区域列表
    getdata(parm) {
      this.loading = true;
      // 模拟数据
      let res = {
        data: [
          { id: "1", areaName: "1111", areaNumber: "11111111", remarks: "" }
        ]
      };
      this.loading = false;
      this.listData = res.data;
    },

    


  

  
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      // this.getdata();
    },
    carFather() {
      this.carInline.page = this.pageCar.currentPage;
      this.carInline.limit = this.pageCar.pageSize;
      // this.getCarData();
    },
    lineFather() {
      this.lineInline.page = this.pageLine.currentPage;
      this.lineInline.limit = this.pageLine.pageSize;
      // this.getLineData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      // this.getdata();
    },
    searchCar() {
      this.carInline.page = 1;
      // this.getCarData();
    },
    searchLine() {
      this.lineInline.page = 1;
      // this.getLineData();
    },

    // 操作按钮
    handleOperation() {
      console.log("您点击了操作");
    },
    //添加界面
    handleAdd() {
      this.addFormVisible = true;
      this.addtitle = "添加";
      this.addForm = {};
    },
    // 添加页面保存方法
    submitAddForm(addData) {
      this.$refs[addData].validate(valid => {
        if (valid) {
          
        } else {
          return false;
        }
      });
    },
    //显示编辑界面
    handleEdit(row) {
      this.title = "修改";
      // this.addtitle = "添加";
      this.editForm = {};
      this.editFormVisible = true;
      
    },
    // 编辑页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          
        } else {
          return false;
        }
      });
    },
    // 删除区域
    delRegion(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning"
      })
        .then(() => { })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //绑定车辆列表
    handleAddCar() {
      this.innerVisible = true;
      this.carInline.car_number = "";
      this.carInline.car_id = "";
      this.carInline.name = "";
      this.carInline.page = 1;
      this.carInline.limit = 10;
    },
    //选择车辆
    handleSelectionChange(val) {
      this.car_idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.car_idsval.includes(val[i])) {
          this.car_idsval.push(val[i]);
        }
      }
    },
    //添加未绑定车辆
    submitAddCar() {
      this.innerVisible = false;
      for (var i = 0; i < this.car_idsval.length; i++) {
        this.car_ids.push(this.car_idsval[i].id);
      }
      var strs = this.car_ids.join(",");
      if (strs) {
      }
    },
    //解除绑定车辆
    delCar(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning"
      })
        .then(() => { })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //绑定线路列表
    handleAddLine() {
      this.lineVisible = true;
      this.lineInline.line_name = "";
      this.lineInline.line_id = "";
      this.lineInline.status = "";
      this.lineInline.page = 1;
      this.lineInline.limit = 10;
      // this.getLineData();
      this.toggleRowSelectEdit();
    },
    //选择线路
    handleSelectionChangeLine(val) {
      this.line_idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.line_idsval.includes(val[i])) {
          this.line_idsval.push(val[i]);
        }
      }
    },
    //添加未绑定的线路
    submitAddLine() {
      this.lineVisible = false;
      for (var i = 0; i < this.line_idsval.length; i++) {
        this.line_ids.push(this.line_idsval[i].id);
      }
      var strs = this.line_ids.join(",");
      if (strs) {

      }
    },
    //解除绑定线路
    delLine(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning"
      })
        .then(() => {
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSizeCarChange(val) {
      this.pageCar.pageSize = val;
      this.carFather();
    },
    handleCurrentCarChange(val) {
      this.pageCar.currentPage = val;
      this.carFather();
    },
    handleSizeLineChange(val) {
      this.pageLine.pageSize = val;
      this.lineFather();
    },
    handleCurrentLineChange(val) {
      this.pageLine.currentPage = val;
      this.lineFather();
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.addFormVisible = false;
      this.$refs[formName].resetFields();
      // this.getdata();
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 30px;
  width: 100%;
  height: 80px;
}

.userRole {
  width: 100%;
}

.adddefine {
  margin-bottom: 10px;
}

.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 8%;
  left: 97%;
}
</style>


// WEBPACK FOOTER //
// src/views/area_mn/Area_mn.vue